module.exports = __webpack_public_path__ + "media/images/chevron-left-c17e47d6d31af05e185daf24019f89d7.svg";